import type { EmdrSetRecord } from "./emdrSets";

export type EmdrSetsSummary = {
    count: number;
    /** The first SUD rated in the session — where the target started. */
    firstSud: number | null;
    /** The last SUD rated — where it ended. */
    lastSud: number | null;
    /** The last VOC rated — how true the positive cognition felt at the end. */
    lastVoc: number | null;
};

export function summarizeSets(sets: EmdrSetRecord[]): EmdrSetsSummary {
    const suds = sets.map((s) => s.sud).filter((v): v is number => v !== null);
    const vocs = sets.map((s) => s.voc).filter((v): v is number => v !== null);
    return {
        count: sets.length,
        firstSud: suds[0] ?? null,
        lastSud: suds.at(-1) ?? null,
        lastVoc: vocs.at(-1) ?? null,
    };
}

export type SudPoint = { setNumber: number; sud: number };

/** The SUD curve: one point per set that was rated, in the order they ran. */
export function sudPoints(sets: EmdrSetRecord[]): SudPoint[] {
    return sets.filter((s) => s.sud !== null).map((s) => ({ setNumber: s.set_number, sud: s.sud as number }));
}

/** One rating across the sets that have it, in the order they ran. */
export function ratingPoints(sets: EmdrSetRecord[], rating: "sud" | "voc"): { setNumber: number; value: number }[] {
    return sets
        .filter((s) => s[rating] !== null)
        .map((s) => ({ setNumber: s.set_number, value: s[rating] as number }));
}
